import { fieldIsValid } from "../../../../../lib/helper";
import { DatePicker } from "../../../../../../common/Atoms/DatePicker";

import { IFieldProps } from "./fieldProps";

export function ApplyInvoicesTo({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  return (
    <DatePicker
      className={ `min-w-full` }
      label={ `Applies to invoices due until` }
      onChange={ handleChange }
      name={ `apply_before_due_date_string` }
      invalid={ fieldIsValid(`apply_before_due_date_string`, invalids) }
      value={
        policyFormData.apply_before_due_date_string === null
          ? ``
          : policyFormData.apply_before_due_date_string
      }
    />
  );
}
